import React from 'react';
import PropTypes from 'prop-types';
import { classList } from 'utils/componentsCommon';
import Link from 'next/link';

const Button = ({ children, className, size, color, variant, active, noshadow, href, ...props }) => {
    const classNames = classList(
        size && `size-${size}`,
        color && `color-${color}`,
        variant && `variant-${variant}`,
        active && 'active',
        noshadow && 'noshadow',
        className);

    if (href === undefined) {
        return <button className={ classNames } { ...props }>{ children }</button>;
    }

    const hrefValue = href !== undefined ? href : '';
    return <Link href={ hrefValue } passHref><button className={ classNames } { ...props }>{ children }</button></Link>;
};

Button.defaultProps = {
    size: 'medium',
    color: 'default',
    variant: 'contained',
};

Button.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string,
};

export default Button;
